// Converts an ISO timestamp (or a YYYY-MM-DD string) to the YYYY-MM-DD
// Australia/Brisbane (AEST, no DST) calendar day it falls on. Mirrors
// getBrisbaneToday's formatter so the two agree on the day boundary.
//
// Why this exists: the issue derivations (deriveIssueDisplay /
// deriveIssueActionState) take YYYY-MM-DD Brisbane days, but the backend
// stores raisedAt / statusEnteredAt / action doneAt as full ISO instants
// (new Date().toISOString()). Passing a raw instant straight into the
// derivation produced `Date.parse("…ZT00:00:00Z")` → NaN → "NaNd". Normalise
// the instant to its Brisbane calendar day at the call site first. A date-only
// input (e.g. an action dueDate from <input type="date">) round-trips
// unchanged. Returns "" for an empty/absent input so callers can guard.

const BRISBANE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Australia/Brisbane",
});

export function toBrisbaneDay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return BRISBANE_FMT.format(d);
}
